export const QUERY_RETRY_DELAY_MS = 2000;
export const QUERY_TIMEOUT_MS = 30 * 1000;
